import Controller from '../../close_when_clicked_outside_controller';

export default class extends Controller {
  static targets = ['trigger'];

  toggle() {
    this._opened = !this._opened;
  }

  close() {
    this._opened = false;
  }

  // Insurance only: Cache-Control: no-store keeps these pages out of the bfcache today.
  closeOnRestore(event) {
    if (event.persisted) {
      this.close();
    }
  }

  get _opened() {
    return this.element.classList.contains('is-open');
  }

  set _opened(value) {
    this.element.classList.toggle('is-open', value);
    this.triggerTarget.setAttribute('aria-expanded', String(value));
  }
}
